function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import slugify from 'slugify';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import { actions as modalActions } from '../../../reducers/modal.reducer';
import RichTextEditor from 'react-rte';
import LocationData from '../Location.context';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Label from '../../common/form/Label.react';
import Input from '../../common/form/Input.react';
import Button from '../../common/Button.react';
var PpcPageDetails = function PpcPageDetails() {
  var dispatch = useDispatch();
  var _useContext = useContext(LocationData),
    _useContext2 = _slicedToArray(_useContext, 2),
    state = _useContext2[0],
    setState = _useContext2[1];
  var locationID = state._id,
    clientApp = state.clientApp,
    name = state.name,
    internalUrl = state.internalUrl,
    slug = state.slug,
    address = state.address,
    secondaryAddress = state.secondaryAddress,
    contact = state.contact,
    googleMapsURL = state.googleMapsURL,
    coords = state.coords,
    archived = state.archived,
    paragraph = state.paragraph;
  var setAddress = function setAddress(key, val) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      address: _objectSpread(_objectSpread({}, state.address), {}, _defineProperty({}, key, val))
    }));
  };
  var setSecondaryAddress = function setSecondaryAddress(key, val) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      secondaryAddress: _objectSpread(_objectSpread({}, state.secondaryAddress), {}, _defineProperty({}, key, val))
    }));
  };
  var setContact = function setContact(key, val) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      contact: _objectSpread(_objectSpread({}, state.contact), {}, _defineProperty({}, key, val))
    }));
  };
  var setCoords = function setCoords(key, val) {
    setState(_objectSpread(_objectSpread({}, state), {}, {
      coords: _objectSpread(_objectSpread({}, state.coords), {}, _defineProperty({}, key, val))
    }));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Location Details"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Label, {
    label: "Location Name",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: name,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        name: e.target.value,
        slug: slugify(e.target.value.toLowerCase())
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Slug",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: slug,
    disabled: true
    // onChange={e => setState({ ...state, name: e.target.value })}
  }), /*#__PURE__*/React.createElement(Label, {
    label: "URL",
    required: true
  }), /*#__PURE__*/React.createElement(Input, {
    value: internalUrl,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        internalUrl: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Paragraph"
  }), paragraph && /*#__PURE__*/React.createElement(RichTextEditor, {
    value: paragraph,
    className: "a-editor__editor",
    onChange: function onChange(val) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        paragraph: val
      }));
    }
  }), clientApp === 'construx' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    style: {
      marginBottom: 10
    }
  }, (address === null || address === void 0 ? void 0 : address.label) || 'address label'), /*#__PURE__*/React.createElement(Input, {
    value: address === null || address === void 0 ? void 0 : address.label,
    onChange: function onChange(e) {
      return setAddress('label', e.target.value);
    }
  })), /*#__PURE__*/React.createElement(Label, {
    label: "Street"
  }), /*#__PURE__*/React.createElement(Input, {
    value: address === null || address === void 0 ? void 0 : address.street,
    onChange: function onChange(e) {
      return setAddress('street', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "City"
  }), /*#__PURE__*/React.createElement(Input, {
    value: address === null || address === void 0 ? void 0 : address.city,
    onChange: function onChange(e) {
      return setAddress('city', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "State"
  }), /*#__PURE__*/React.createElement(Input, {
    value: address === null || address === void 0 ? void 0 : address.state,
    onChange: function onChange(e) {
      return setAddress('state', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Zip"
  }), /*#__PURE__*/React.createElement(Input, {
    value: address === null || address === void 0 ? void 0 : address.zip,
    onChange: function onChange(e) {
      return setAddress('zip', e.target.value);
    }
  }), clientApp === 'construx' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h2", {
    style: {
      marginBottom: 10
    }
  }, (secondaryAddress === null || secondaryAddress === void 0 ? void 0 : secondaryAddress.label) || 'address label'), /*#__PURE__*/React.createElement(Input, {
    value: secondaryAddress === null || secondaryAddress === void 0 ? void 0 : secondaryAddress.label,
    onChange: function onChange(e) {
      return setSecondaryAddress('label', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Street"
  }), /*#__PURE__*/React.createElement(Input, {
    value: secondaryAddress === null || secondaryAddress === void 0 ? void 0 : secondaryAddress.street,
    onChange: function onChange(e) {
      return setSecondaryAddress('street', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "City"
  }), /*#__PURE__*/React.createElement(Input, {
    value: secondaryAddress === null || secondaryAddress === void 0 ? void 0 : secondaryAddress.city,
    onChange: function onChange(e) {
      return setSecondaryAddress('city', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "State"
  }), /*#__PURE__*/React.createElement(Input, {
    value: secondaryAddress === null || secondaryAddress === void 0 ? void 0 : secondaryAddress.state,
    onChange: function onChange(e) {
      return setSecondaryAddress('state', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Zip"
  }), /*#__PURE__*/React.createElement(Input, {
    value: secondaryAddress === null || secondaryAddress === void 0 ? void 0 : secondaryAddress.zip,
    onChange: function onChange(e) {
      return setSecondaryAddress('zip', e.target.value);
    }
  })), /*#__PURE__*/React.createElement(Label, {
    label: "Contact Person"
  }), /*#__PURE__*/React.createElement(Input, {
    value: contact === null || contact === void 0 ? void 0 : contact.person,
    onChange: function onChange(e) {
      return setContact('person', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Email"
  }), /*#__PURE__*/React.createElement(Input, {
    value: contact === null || contact === void 0 ? void 0 : contact.email,
    onChange: function onChange(e) {
      return setContact('email', e.target.value.toLowerCase());
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Phone Number"
  }), /*#__PURE__*/React.createElement(Input, {
    value: contact === null || contact === void 0 ? void 0 : contact.phone,
    onChange: function onChange(e) {
      return setContact('phone', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Mobile Number"
  }), /*#__PURE__*/React.createElement(Input, {
    value: contact === null || contact === void 0 ? void 0 : contact.cell,
    onChange: function onChange(e) {
      return setContact('cell', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Google Maps URL"
  }), /*#__PURE__*/React.createElement(Input, {
    value: googleMapsURL,
    onChange: function onChange(e) {
      return setState(_objectSpread(_objectSpread({}, state), {}, {
        googleMapsURL: e.target.value
      }));
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Latitude"
  }), /*#__PURE__*/React.createElement(Input, {
    value: coords === null || coords === void 0 ? void 0 : coords.lat,
    onChange: function onChange(e) {
      return setCoords('lat', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Label, {
    label: "Longitude"
  }), /*#__PURE__*/React.createElement(Input, {
    value: coords === null || coords === void 0 ? void 0 : coords.lng,
    onChange: function onChange(e) {
      return setCoords('lng', e.target.value);
    }
  }), !archived && /*#__PURE__*/React.createElement(Button, {
    label: "Update",
    apiID: "update-location",
    onClick: function onClick() {
      dispatch({
        type: ppcActions.location,
        payload: {
          formData: {
            locationID: locationID,
            name: name,
            address: address,
            secondaryAddress: secondaryAddress,
            contact: contact,
            googleMapsURL: googleMapsURL,
            coords: coords,
            internalUrl: internalUrl,
            slug: slug,
            paragraph: (paragraph === null || paragraph === void 0 ? void 0 : paragraph.toString('html')) || ''
          },
          apiID: 'update-location',
          method: 'put'
        }
      });
      dispatch({
        type: modalActions.hide
      });
    },
    width: "120px"
  }))));
};
export default PpcPageDetails;